import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useContext,
  useState,
} from "react";

import type { TAccession } from "@/lib/types";

type AccessionBoardContextProps = {
  selected: TAccession | null;
  setSelected: Dispatch<SetStateAction<TAccession | null>>;
};

const AccessionBoardContext = createContext({} as AccessionBoardContextProps);

export function AccessionBoardProvider({ children }: { children: ReactNode }) {
  const [selected, setSelected] =
    useState<AccessionBoardContextProps["selected"]>(null);

  return (
    <AccessionBoardContext.Provider value={{ selected, setSelected }}>
      {children}
    </AccessionBoardContext.Provider>
  );
}

export function useBoard() {
  const context = useContext(AccessionBoardContext);
  if (!context) {
    throw new Error("Must call useBoard inside AccessionBoardProvider");
  }
  return context;
}
